import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AuthenticationStatus = 'init' | 'authorized' | 'unauthorized';

interface AuthenticationState {
    status: AuthenticationStatus
};

const initialState: AuthenticationState = {
    status: 'init',
};

export const authenticationSlice = createSlice({
    initialState,
    name: 'authentication',
    reducers: {
        setAuthenticationStatus(state, action: PayloadAction<{ status: AuthenticationStatus }>) {
            state.status = action.payload.status;
        },
    },
});

export const { setAuthenticationStatus } = authenticationSlice.actions;
